<template>
  <!--
    Standard breadcrumb.
    Pattern source: pages/_uniSlug/programs/index.vue (.pc-breadcrumb).

    Pass an array of items. The last item is treated as the current page (no link).
      [
        { label: 'Home', to: '/' },
        { label: 'Georgia State University', to: '/georgia-state-university' },
        { label: 'Program catalog' }   // current — no `to`
      ]

    A `to` of false / null / '' renders as plain (current) text even if not last.
  -->
  <nav class="tu-bc" aria-label="Breadcrumb">
    <ol class="tu-bc-list">
      <template v-for="(item, idx) in items">
        <li :key="`crumb-${idx}`">
          <router-link
            v-if="item.to && idx !== items.length - 1"
            :to="item.to"
            class="tu-bc-crumb"
          >{{ item.label }}</router-link>
          <span v-else class="tu-bc-crumb tu-bc-crumb--current" aria-current="page">{{ item.label }}</span>
        </li>
        <li
          v-if="idx < items.length - 1"
          :key="`sep-${idx}`"
          class="tu-bc-sep"
          aria-hidden="true"
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>
        </li>
      </template>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'TuBreadcrumb',
  props: {
    items: {
      type: Array,
      required: true,
      validator: (arr) => arr.every(i => i && typeof i.label === 'string')
    }
  }
}
</script>

<style lang="scss" scoped>
.tu-bc {
  margin-bottom: var(--tu-s-4);
}

.tu-bc-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem 0.5rem;
  font-family: var(--tu-font-text);
  font-size: var(--tu-fs-micro);
  font-weight: var(--tu-fw-semi);
  letter-spacing: 0;
  text-transform: none;
  color: var(--tu-ink-mute);
}

.tu-bc-sep {
  display: flex;
  color: var(--tu-line-strong);
}

/* Beat `.v-application .v-application--wrap a { color: primary }` (vuetify-overide.scss) */
.v-application .v-application--wrap a.tu-bc-crumb {
  color: var(--tu-blue-deep);
  text-decoration: none;
  text-transform: none;
  letter-spacing: 0;
  border-bottom: 1px solid transparent;
  transition: color var(--tu-dur-fast) var(--tu-ease),
              border-color var(--tu-dur-fast) var(--tu-ease);

  &:hover,
  &.nuxt-link-active:hover {
    color: var(--tu-blue);
    border-bottom-color: rgba(59, 134, 245, 0.4);
  }
}

.v-application .v-application--wrap a.tu-bc-crumb.nuxt-link-active,
.v-application .v-application--wrap a.tu-bc-crumb.nuxt-link-exact-active {
  color: var(--tu-blue-deep);
}

.tu-bc-crumb--current {
  color: var(--tu-ink);
  font-weight: var(--tu-fw-bold);
  text-transform: none;
  letter-spacing: 0;
  border: 0;
}
</style>
